import {Link} from 'react-router-dom'
import {BsPlusSquare, BsDashSquare} from 'react-icons/bs'
import {FiTrash2} from 'react-icons/fi'

import CartContext from '../../context/CartContext'

import './index.css'

const CartItem = props => (
  <CartContext.Consumer>
    {value => {
      const {
        removeCartItem,
        incrementCartItemQuantity,
        decrementCartItemQuantity,
      } = value
      const {cartItemDetails} = props
      const {id, title, brand, quantity, price, imageUrl} = cartItemDetails
      const onRemoveCartItem = () => {
        removeCartItem(id)
      }

      // TODO: Update the functionality to increment and decrement quantity of the cart item
      const onClickIncrementQuantity = () => {
        incrementCartItemQuantity(id)
      }

      const onClickDecrementQuantity = () => {
        decrementCartItemQuantity(id)
      }

      return (
        <li className="cart-item">
          <div className="cart-item-upper-row">
            <img className="cart-product-image" src={imageUrl} alt={title} />
            
            <div className="cart-item-info">
              <Link to={`/products/${id}`} className="cart-product-title-link">
                <p className="cart-product-title">{title}</p>
              </Link>
              <p className="cart-product-brand">by {brand}</p>
              <div className="cart-prices-mobile">
                {quantity > 1 && (
                  <p className="cart-unit-price">₹{price} each</p>
                )}
                <p className="cart-total-price-mobile">₹{price * quantity}</p>
              </div>
            </div>
          </div>
          
          <div className="cart-item-lower-row">
            <button
              className="delete-button"
              type="button"
              data-testid="remove"
              onClick={onRemoveCartItem}
            >
              <FiTrash2 className="delete-icon" /> <span className="delete-text">Remove</span>
            </button>

            <div className="cart-quantity-container">
              <div className="quantity-stepper">
                <button
                  type="button"
                  className="quantity-controller-button"
                  data-testid="minus"
                  onClick={onClickDecrementQuantity}
                >
                  <BsDashSquare color="#52606D" size={16} />
                </button>
                <p className="cart-quantity">{quantity}</p>
                <button
                  type="button"
                  className="quantity-controller-button"
                  data-testid="plus"
                  onClick={onClickIncrementQuantity}
                >
                  <BsPlusSquare color="#52606D" size={16} />
                </button>
              </div>
            </div>
          </div>
          
          <div className="cart-subtotal-action desktop-only">
            <p className="cart-total-price">₹{price * quantity}</p>
            <button
              className="delete-button-desktop"
              type="button"
              data-testid="remove-desktop"
              onClick={onRemoveCartItem}
            >
              <FiTrash2 className="delete-icon" /> <span className="delete-text">Remove</span>
            </button>
          </div>
        </li>
      )
    }}
  </CartContext.Consumer>
)

export default CartItem
